import { IGeneric } from "./interfaces/generic.interface";
import { IPathway } from "./interfaces/modules.interface";

export const APP_CONFIGS = {
    key: "EMPLOYEE",
    title: "Prosperh App",
    api: {
        base: "employee"
    },
    analyticsId: "G-R1HVKBFB4E"
};

export const CONTENT_BASE_URL = process.env.REACT_APP_BASE_CONTENT_API_URL;

export const COOKIES = {
    TOKEN: "tk",
    REFRESH_TOKEN: "rtk",
    LANGUAGE: "lang"
};

export const LOCALE: IGeneric = {
    pt: "pt",
    en: "en",
    sq: "sq",
    hu: "hu-HU",
    es: "es",
    da: "da-DK",
    tr: "tr",
    nl: "nl",
    de: "de"
};

export const LOCALE_LABELS: IGeneric = {
    pt: "Português (PT)",
    en: "English (EN)",
    sq: "Shqip (SQ)",
    hu: "Magyar (HU)",
    es: "Español (SP)",
    da: "Dansk (DEN)",
    tr: "Türkçe (TR)",
    nl: "Dutch (NL)",
    de: "Deutsch (DE)"
};

export const DEFAULT_LANGUAGE = LOCALE.en;

export const PATHWAYS: IPathway = {
    0: "PATHWAY_1",
    1: "PATHWAY_1",
    2: "PATHWAY_2",
    3: "PATHWAY_3",
    4: "PATHWAY_4",
    5: "PATHWAY_5",
    6: "PATHWAY_6",
    7: "PATHWAY_7",
    8: "PATHWAY_8",
    9: "PATHWAY_9"
};

export const MODULE_TYPES = {
    PSYCHOEDUCATIONAL: "PSYCHOEDUCATIONAL",
    REGULAR: "REGULAR"
}
